export default __webpack_public_path__ + "static/media/trumpet.2eff5f11.png";